import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueMask from "v-mask";
import Vidle from "v-idle";
import "./assets/font/index";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "./plugins";

Vue.config.productionTip = false;
Vue.use(Vidle);
store.dispatch("initData").then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App)
  }).$mount("#app");
});
Vue.use(VueMask);
